import React, { createElement } from 'react';
import { oneOf, func, string, bool } from 'prop-types';
import MuiIconButton from '@mui/material/IconButton';
import { Icons } from '../..';
import { ButtonWrapper } from './IconButton.styles';
export const renderIconButton = icon => icon ? /*#__PURE__*/createElement(Icons[icon]) : undefined;
export const IconButton = _ref => {
  let {
    size,
    color,
    onClick,
    icon,
    variant,
    disabled,
    label
  } = _ref;
  const handleClick = event => {
    event.preventDefault();
    return onClick(event);
  };
  return /*#__PURE__*/React.createElement(ButtonWrapper, {
    color: color,
    variant: variant,
    size: size,
    "data-test-id": "button"
  }, /*#__PURE__*/React.createElement(MuiIconButton, {
    "data-test-id": "icon-button",
    disableRipple: true,
    disabled: disabled,
    onClick: event => handleClick(event),
    "aria-label": label
  }, renderIconButton(icon)));
};
IconButton.propTypes = {
  onClick: func.isRequired,
  size: oneOf(['medium', 'small', 'large']),
  color: oneOf(['blue', 'green', 'purple', 'grey']),
  icon: string,
  disabled: bool,
  variant: oneOf(['filled', 'plained']),
  label: string
};
IconButton.defaultProps = {
  size: 'medium',
  color: 'blue',
  icon: 'tickBold',
  variant: 'filled',
  disabled: false,
  label: ''
};